export function getView(width) {
  let newView = 'MobileView';
  if (width > 992 ) {
    newView = 'DesktopView';
  } else if (width >= 768) {
    newView = 'TabView';
  }
  return newView;
}
const actions = {
  REDIRECT_TO : 'REDIRECT_TO',
  UPDATE_APP_VIEW: 'UPDATE_APP_VIEW',
  UPDATE_APP_HEIGHT: 'UPDATE_APP_HEIGHT',
  SET_IS_HAMBURGER_MENU_COLLAPSED: 'SET_IS_HAMBURGER_MENU_COLLAPSED',
  
  redirectTo: (url) =>({
    type: actions.REDIRECT_TO,
    url:url
  }),  
  updateAppView: (width) => ({
    type: actions.UPDATE_APP_VIEW,
    width
  }),  
  updateAppHeight: (height) => ({
    type: actions.UPDATE_APP_HEIGHT,
    height
  }),
  setIsHamburgerMenuCollapsed: (isCollapsed) => ({
    type: actions.SET_IS_HAMBURGER_MENU_COLLAPSED,
    isCollapsed: isCollapsed
  })
};
export default actions;
